export default {
  token: null,
  registerToken: null,
  forgotCheck: false,

  registerCode: null,
  checkNewRegister: false,
  forgotCode: null,

  profile: {},
  companies: [],
  company: {},
  printCompany: [],
  militaryService: [],

  transactions: [],
  wallet: null,
  paymentGateway: null,
  paymentResult: null,

  billSubjects: [],
  billTypes: [],
  billPatterns: [],
  buyerTypes: [],
  flightTypes: [],
  clearingMethods: [],
  paymentTypes: [],
  unitMeasurements: [],
  currencyTypes: [],

  invoices: [],
  invoiceById: [],
  inquiryInvoiceLogs: [],
  inquiryCheck: false,
  invoiceFileLink: null,
  printAddress: null,

  taxKeys: [],
  taxKeyByNational: {},
  publicKeyLink: null,
  pfxResult: {},

  companyFinalPrice: {},

  jobAdvertisement: [],
  jobAdvertisementById: {},

  jobRequest: [],
  jobRequestById: {},
  
  news: [],
  newsDetail: {},
};
